module.exports = __webpack_public_path__ + "static/media/tasks.e6fd7f69.svg";